<template>
	<div :style="{background:styles.background,borderRadius:styles.borderRadius+'px'}" class="focalentry">
		
		<div class="focalentry_flex">
			<div>
				<div class="focalentry_hello" :style="{color:styles.fontcolor }">{{params.welcome || ''}}</div>
				<div class="focalentry_flex_left ">
					<span class="focalentry_flex_name" :style="{color:styles.fontcolor }">微信昵称</span>
					<span :style="{background:styles.color }" class="focalentry_flex_level">VIP1</span>
				</div>
			</div>
			<div :style="{borderColor:styles.background,background:styles.background }" class="focalentry_user">
				<img src="@/assets/vip/user-avatar.png" alt="" />
			</div>
			<!-- <div :style="{background:styles.color }" class="focalentry_code">{{params.code || ''}}</div> -->
		</div>
		<div class="focalentry_per">
			<div :style="{background:styles.color }" class="focalentry_per_w"></div>
		</div>
		<div class="focalentry_tips" :style="{color:styles.fontcolor }">再消费500元升为V2</div>
		<div class="focalentry_tab">
			<div v-for="(item,index) in dataItem" :key class="focalentry_tab_item">
				<img class="focalentry_tab_img" v-if="item.imgUrl" :src="item.imgUrl || 'https://mp.mocols.com/common/admin/admin_banner.jpg'" alt="" />
				<div v-if="item.text" :style="{color:styles.fontcolor }" class="focalentry_tab_title">{{item.text}}</div>
				<div v-if="item.sub" :style="{color:styles.fontcolor }" class="focalentry_tab_english">{{item.sub}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'focalentryBox',
	  props: {
	    params: {
			type:Object
		},
		styles: {
			type:Object
		},
		dataItem: {
			type:Array,
			defaultL:()=>[]
		}
	  },
	  data () {
	    return {}
	  }
	}
</script>

<style lang="scss" scoped>
	.focalentry{
		margin-top: 10px;
		padding:25px 12px 12px 12px;
		position: relative;
		&_user{
			border-radius: 50%;
			img{
				width: 35px;
				height: 35px;
				border-radius: 50%;
				display: block;
			}
		}
		&_hello{
			font-size: 14px;
		}
		&_flex{
			display: flex;
			align-items: center;
			justify-content: space-between;
			&_name{
				font-size: 14px;
				font-weight: bold;
				color:#000
			}
			&_level{
				height: 16px;
				line-height: 16px;
				display: inline-block;
				padding: 0 5px;
				color: #fff;
				margin-left: 4px;
				border-radius: 10px;
				font-size: 10px;
			}
		}
		&_code{
			font-size: 14px;
			font-weight: bold;
			display: inline-block;
			height: 26px;
			line-height: 26px;
			color: #fff;
			padding: 0 10px;
			border-radius: 16px;
		}
		&_per{
			height: 10px;
			border-radius: 5px;
			width: 100%;
			overflow: hidden;
			background-color: #f9f9f9;
			position: relative;
			margin-top: 10px;
			&_w{
				height: 10px;
				position: absolute;
				left: 0;
				width:40%;
				border-radius: 5px;
			}
		}
		&_tips{
			margin-top: 5px;
			font-size: #eee;
		}
		
		&_tab{
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-top: 20px;
			&_item{
				text-align: center;
				flex: 1;
				position: relative;
			}
			&_img{
				width:50px;
				height:50px;
				display: block;
				margin-left: auto;
				margin-right: auto;
			}
			&_title{
				font-size: 16px;
				color: #000;
				margin-top: 5px;
			}
			&_english{
				font-size: 12px;
				color: #999;
			}
		}
	}
</style>